export const GLOBAL_SEARCH_RESULT = "GLOBAL_SEARCH_RESULT";
export const GLOBAL_SEARCH_LOADER = "GLOBAL_SEARCH_LOADER";
export const PREVIEW_RECORD = "PREVIEW_RECORD";
export const ASSET_FILTERS = "ASSET_FILTERS";
export const SET_ASSET_FILTERS = "SET_ASSET_FILTERS";
export const DOWNLOAD_LOADER = "DOWNLOAD_LOADER";
